import { useState, useEffect } from "react";
import { fetchExperimentVariants, getVariant } from "@/lib/amplitude";

export type OnboardingVariant = "A" | "B";

export function useOnboardingVariant(): {
  variant: OnboardingVariant;
  isLoading: boolean;
} {
  const [variant, setVariant] = useState<OnboardingVariant | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadVariant() {
      try {
        // Fetch variants from Amplitude Experiment
        await fetchExperimentVariants();

        // Get the variant for our onboarding experiment
        const variantValue = getVariant("onboarding_flow_test");

        // Map variant values to A or B
        if (variantValue === "paginated-flow") {
          setVariant("A");
        } else {
          // Default to B (control - current interactive flow)
          setVariant("B");
        }
      } catch (error) {
        console.error("Failed to fetch variant:", error);
        // Fallback to control variant on error
        setVariant("B");
      } finally {
        setIsLoading(false);
      }
    }

    loadVariant();
  }, []);

  return {
    variant: variant || "B",
    isLoading,
  };
}
